import type { ReactElement } from 'react';
import { api } from '../../../utils/api.ts';
import { SearchSelect } from './search-select.tsx';

export type StorageLocationInputProps = {
    className?: string;
    disabled?: boolean;
    onChange?: (id: string) => void;
    placeholder?: string;
    value?: string;
};

export function StorageLocationInput({
    className,
    disabled,
    onChange,
    placeholder,
    value,
}: StorageLocationInputProps): ReactElement {
    const { data, isLoading } = api.platoUser.writeBackOptionsHeader.getCustomerStorageLocations.useQuery({});

    return (
        <SearchSelect
            className={className}
            disabled={disabled}
            items={data}
            idSelector={(x) => x.id}
            isLoading={isLoading}
            onSelectedIdChange={onChange}
            placeholder={placeholder}
            renderItem={(x) => `${x.id}: ${x.name}`}
            selectedId={value}
            textSelector={(x) => `${x.id}: ${x.name}`}
        />
    );
}
